import React from 'react';
import { useServicesContext, useClientServerUtils } from '@oneaudi/vtp-shared';
import { ContentService } from '@oneaudi/content-service';
import Favorites from './Favorites';
import Results from './Results';
import { SELECTORS } from '@oneaudi/stck-store';
import { useSelector } from 'react-redux';
import { TilesSkeleton } from './Skeleton/TilesSkeleton';

interface TilesWrapperProps {}
const TilesWrapper: React.FC<TilesWrapperProps> = () => {
  const servicesContext = useServicesContext();
  const isLoading = useSelector((state) => SELECTORS.UI.getLoadingState(state));
  const audiContentService = servicesContext.getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const content = audiContentService.getContent();

  const appContext: 'favorites' | 'results' = content.fields.appContext || 'results';

  const { isClient } = useClientServerUtils();

  if (isLoading || !isClient) {
    // render skeleton when Loading or on SSR...
    return <TilesSkeleton />;
  }

  return appContext === 'favorites' ? <Favorites /> : <Results />;
};

export default TilesWrapper;
